import React from 'react';
import Button from './Button';

export default function Hero() {
  return (
    <section id="hero" style={{
      minHeight: '100vh',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
    }}>

      {/* FULL BACKGROUND IMAGE — save your photo as public/images/hero.jpg */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'url(/images/hero.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
      }} />

      {/* Gradient overlay — dark left, transparent right */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(to right, rgba(15,35,64,0.96) 0%, rgba(15,35,64,0.88) 40%, rgba(15,35,64,0.45) 65%, rgba(15,35,64,0.05) 100%)',
      }} />

      {/* Fallback background if no image */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(135deg, var(--navy) 0%, var(--blue) 60%, #1e5fa0 100%)',
        zIndex: -1,
      }} />

      {/* BG pattern */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E")`,
        pointerEvents: 'none',
      }} />

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .hero-content { animation: fadeUp 0.9s ease both; }
        @media (max-width: 768px) {
          #hero { text-align: center; }
          .hero-btns { justify-content: center !important; }
        }
      `}</style>

      {/* Content */}
      <div className="hero-content" style={{
        position: 'relative', zIndex: 2,
        maxWidth: 620, padding: '0 5%', width: '100%',
      }}>
      

        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(2.2rem, 5vw, 3.4rem)',
          color: '#fff', lineHeight: 1.15, marginBottom: 16,
        }}>
          Professional Cleaning<br />
          Services in <em style={{ color: 'var(--orange)', fontStyle: 'normal' }}>SE1 London</em>
        </h1>

        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '1rem', letterSpacing: '0.5px', marginBottom: 16 }}>
          Waterloo · Southwark · London Bridge · Elephant &amp; Castle
        </p>

        <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', marginBottom: 36, lineHeight: 1.6 }}>
          Airbnb &amp; Short Let Cleaning &nbsp;·&nbsp; End of Tenancy Cleaning &nbsp;·&nbsp; Residential Cleaning
        </p>

        <div className="hero-btns" style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
          <Button href="#contact">Get a Free Quote</Button>
          <a href="tel:+447853481188" style={{
  display: 'inline-flex', alignItems: 'center', gap: 8,
  background: 'transparent', color: '#fff',
  padding: '14px 30px', borderRadius: 8, fontWeight: 500,
  fontSize: '0.95rem', textDecoration: 'none',
  border: '1.5px solid rgba(255,255,255,0.4)',
  transition: 'border-color 0.25s, background 0.25s',
}}
  onMouseEnter={e => { e.currentTarget.style.borderColor = '#fff'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'; e.currentTarget.style.background = 'transparent'; }}>
  📞 Call Us: 07853 481188
</a>
        </div>
      </div>
    </section>
  );
}
